<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-inactivity-description') }}
        </p>
        <div class="field">
            <label :class="{ label: true, 'label-danger': !isValid() }"
                >{{ t('automations-form-triggers_config-inactivity-days_label') }}
            </label>
            <input
                type="number"
                name="inactivityDays"
                v-model="inactivityDays"
                class="form-control"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let days =
            this.value.length > 0 && this.value[0].inactivityDays
                ? parseInt(this.value[0].inactivityDays)
                : "";
        return {
            inactivityDays: days,
        };
    },
    computed: {},
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid: function () {
            return !!this.inactivityDays;
        },
        changed: function () {
            this.$emit("input", [{ inactivityDays: this.inactivityDays }]);
        },
    },
    watch: {
        inactivityDays: function () {
            this.changed();
        },
        value: function () {
            let days =
                this.value.length > 0 && this.value[0].inactivityDays
                    ? parseInt(this.value[0].inactivityDays)
                    : "";
            if (days !== this.inactivityDays) {
                this.inactivityDays = days;
            }
        },
    },
};
</script>
